import { render, staticRenderFns } from "./ManageCourseUpdate.vue?vue&type=template&id=5f34ab76&"
import script from "./ManageCourseUpdate.vue?vue&type=script&lang=js&"
export * from "./ManageCourseUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports